import { combineReducers } from 'redux';
import { reducer as analytics } from '@redbubble/boom-analytics';
import { reducer as browser } from './ducks/browser';
import { reducer as cart } from './ducks/cart';
import { reducer as analyticsData } from './ducks/analytics';
import { reducer as userLocation } from './ducks/userLocation';
import { reducer as rbVisitorID } from './ducks/rbVisitorID';

const noop = (state = {}) => state;

export default function getReducers() {
  return combineReducers({
    browser,
    cart,
    analytics: typeof window === 'undefined' ? noop : analytics,
    analyticsData,
    userLocation,
    rbVisitorID
  });
}
